<template>
  <teleport to="body">
    <transition name="general-filter-drawer">
      <div v-if="modelValue" class="fixed inset-0 z-[1]">
        <div class="absolute inset-0 bg-black/40" @click="close"></div>
        <div class="general-filter-drawer-panel absolute right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl flex flex-col">
          <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h3 class="text-lg font-medium text-primary-3">ตัวกรอง</h3>
            <button type="button" class="text-gray-400 hover:text-gray-600" @click="close">
              <XIcon class="w-5 h-5" />
            </button>
          </div>

          <div class="flex-1 overflow-y-auto px-6 py-5 space-y-6">
            <div>
              <h4 class="text-sm font-semibold text-primary-3 mb-3">สถานะตรวจสอบ</h4>
              <SegmentToggle v-model="filterState.verifiedStatus" :options="verifiedStatusOptions" />
            </div>

            <div v-if="showAgeGroup">
              <h4 class="text-sm font-semibold text-primary-3 mb-3">ช่วงวัย</h4>
              <div class="space-y-3">
                <label
                  v-for="opt in ageGroupOptions"
                  :key="opt.value"
                  class="flex items-center gap-3 cursor-pointer group"
                >
                  <input
                    type="checkbox"
                    :value="opt.value"
                    v-model="filterState.ageGroups"
                    class="w-4 h-4 rounded border-gray-300 text-primary-1 focus:ring-primary-1 cursor-pointer"
                  />
                  <span class="text-sm text-gray-700 group-hover:text-primary-3 select-none">{{ opt.label }}</span>
                </label>
              </div>
            </div>
<!-- 
            <hr class="border-gray-100" />
            <div>
              <h4 class="text-sm font-semibold text-primary-3 mb-3">สภาพปัญหา</h4>
              <div class="space-y-3">
                <label
                  v-for="opt in problemConditionOptions"
                  :key="opt.value"
                  class="flex items-center gap-3 cursor-pointer group"
                >
                  <input
                    type="checkbox"
                    :value="opt.value"
                    v-model="filterState.problemConditions"
                    class="w-4 h-4 rounded border-gray-300 text-primary-1 focus:ring-primary-1 cursor-pointer"
                  />
                  <span class="text-sm text-gray-700 group-hover:text-primary-3 select-none">{{ opt.label }}</span>
                </label>
              </div>
            </div> -->
          </div>

          <div class="px-6 py-4 border-t border-gray-100 flex items-center gap-2 justify-end">
            <button
              type="button"
              class="inline-flex items-center gap-1.5 rounded-md border border-gray-300 text-gray-600 px-4 py-2.5 text-sm hover:bg-gray-50"
              @click="reset"
            >
              รีเซ็ต
            </button>
            <button
              type="button"
              class="inline-flex items-center gap-1.5 rounded-md bg-primary-1 text-white px-6 py-2.5 text-sm hover:bg-primary-3"
              @click="apply"
            >
              ดูข้อมูล
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import SegmentToggle from "./SegmentToggle.vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  activeTab: { type: String, default: "" },
});
const emit = defineEmits(["update:modelValue", "apply"]);

const store = useStore();

const showAgeGroup = computed(() => props.activeTab === "household" || props.activeTab === "person");

const verifiedStatusOptions = [
  { label: "ทั้งหมด", value: "all" },
  { label: "ผ่าน", value: "passed" },
];

const INIT_GENERAL_FILTER = { ageGroups: [], problemConditions: [], verifiedStatus: "passed" };

const ageGroupOptions = [
  { label: "เด็กแรกเกิด/ปฐมวัย (อายุ 0-5 ปี)", value: "ปฐมวัย" },
  { label: "วัยเรียน (อายุ 5-14 ปี)", value: "วัยเรียน" },
  { label: "วัยรุ่น/นักศึกษา (อายุ 15-21 ปี)", value: "วัยรุ่น" },
  { label: "วัยผู้ใหญ่/วัยแรงงาน (อายุ 18-59 ปี)", value: "วัยผู้ใหญ่" },
  { label: "วัยผู้สูงอายุ (60 ปีขึ้นไป)", value: "ผู้สูงอายุ" },
];

const problemConditionOptions = [
  { label: "ความมั่นคงทางเศรษฐกิจ (รายได้)", value: "income" },
  { label: "การศึกษาและทักษะที่จำเป็น (การศึกษา)", value: "education" },
  { label: "สถานะทางสุขภาพ (สุขภาพ)", value: "health" },
  { label: "คุณภาพชีวิตความเป็นอยู่ (ความเป็นอยู่)", value: "housing" },
  { label: "การเข้าถึงบริการภาครัฐ", value: "accessibility" }
];

const filterState = reactive({ ...INIT_GENERAL_FILTER, ageGroups: [], problemConditions: [], verifiedStatus: "passed" });

watch(
  () => props.modelValue,
  (isOpen) => {
    if (!isOpen) return;
    const stored = store.getters["dashboardOverviewFilter/generalFilter"] || INIT_GENERAL_FILTER;
    filterState.ageGroups = [...(stored.ageGroups || [])];
    filterState.problemConditions = [...(stored.problemConditions || [])];
    filterState.verifiedStatus = stored.verifiedStatus || "passed";
  }
);

const close = () => emit("update:modelValue", false);

const reset = () => {
  filterState.ageGroups = [];
  filterState.problemConditions = [];
  filterState.verifiedStatus = "passed";
};

const apply = () => {
  store.dispatch("dashboardOverviewFilter/setStore", {
    generalFilter: JSON.parse(JSON.stringify(filterState)),
  });
  emit("apply", JSON.parse(JSON.stringify(filterState)));
  close();
};
</script>

<style scoped>
.general-filter-drawer-enter-active,
.general-filter-drawer-leave-active {
  transition: opacity 0.2s ease;
}
.general-filter-drawer-enter-from,
.general-filter-drawer-leave-to {
  opacity: 0;
}
.general-filter-drawer-enter-active .general-filter-drawer-panel,
.general-filter-drawer-leave-active .general-filter-drawer-panel {
  transition: transform 0.25s ease;
}
.general-filter-drawer-enter-from .general-filter-drawer-panel,
.general-filter-drawer-leave-to .general-filter-drawer-panel {
  transform: translateX(100%);
}
</style>
